import { useEffect } from 'react';
import { useTenants } from '@app/sdk';
import { ComponentErrorBoundary } from '@app/utilities';
import { useGlobalContext } from '../../../GlobalContextProvider';
import { useNavigate } from 'react-router-dom';
import { useRefreshGetMerchants } from '../../../sdk/tms/merchant/UseGetMerchants';

export function TenantSelector() {
  const { tenantId, setTenantId } = useGlobalContext();
  const navigate = useNavigate();
  const { isLoading, data: tenants } = useTenants();
  const refreshMerchants = useRefreshGetMerchants();

  const onChange = (tenantId: string) => {
    setTenantId(tenantId);
    navigate('/');
    refreshMerchants();
  };

  useEffect(() => {
    const savedTenantId = localStorage.getItem('tenantId');
    if (savedTenantId && tenantId == null) {
      setTenantId(savedTenantId);
      return;
    }
    if (tenants && tenants.length > 0) {
      if (!tenantId || tenants.find(t => t.tenandId == tenantId) == undefined) {
        setTenantId(tenants.at(0).tenandId);
      }
    }
  }, [tenantId, tenants]);

  return (
    <ComponentErrorBoundary>
      {isLoading && <div className="ui active centered inline loader" />}
      {!isLoading && tenants && (
        <div
          className="ui form"
          style={{
            marginLeft: 'auto',
            marginRight: '10px',
          }}>
          <div className="field">
            <div className="ui labeled input">
              <div className="ui label">Tenant</div>
              <select onChange={(e) => onChange(e.target.value)} value={tenantId}>
                {tenants.map((tenant) => (
                  <option key={tenant.tenandId} value={tenant.tenandId}>
                    {tenant.tenantName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      )}
    </ComponentErrorBoundary>
  );
}
